/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_280dae6c"]'><div :class='["checkbox-desc-support-demo"]'><view-desc>支持描述文案：{{ checkboxValue }}</view-desc><div :class='["cube-checkbox-example"]'><cube-checkbox :option="(option)" shape="square" :value="checkboxValue" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","checkboxValue", "__mpx_event__", ["value"], undefined]])'></cube-checkbox></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_280dae6c"}'>
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_280dae6c"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_280dae6c"}
  /** script content **/
  require("./desc-support.mpx.js?isComponent&outputPath=components%2Fdesc-support280dae6c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./desc-support.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdesc-support280dae6c%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_280dae6c"],
    ctorType: "component",
    outputPath: "components/desc-support280dae6c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-checkbox':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox/index.mpx?isComponent&outputPath=components%2Findex04c57aca%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>